module.exports = __webpack_public_path__ + "img/tensorFlow.c85eaf50.svg";